import "./app.css";
import "../src/styling/constants/typography.css";
import { AppRouter } from "routes/appRouter";
import { setTokenGetter } from "axiosWithToken";
import { useSession } from "@clerk/clerk-react";

function App() {
  const { session } = useSession();

  setTokenGetter(async () => {
    const token = await session?.getToken({
      template: "bizcrunch-organization",
    });
    return token ?? null;
  });

  return (
    <div
      className="App"
      style={{
        backgroundImage: "url('/assets/bottomGraphic.png')",
        position: "absolute",
        bottom: 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "contain",
      }}
    >
      {" "}
      <AppRouter />
    </div>
  );
}

export default App;
